"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Domain = void 0;
var Domain;
(function (Domain) {
    Domain["Auth"] = "Auth";
    Domain["Checkout"] = "Checkout";
    Domain["Customer"] = "Customer";
    Domain["Doctor"] = "Doctor";
    Domain["External"] = "External";
    Domain["Help"] = "Help";
    Domain["Order"] = "Order";
    Domain["Partner"] = "Partner";
    Domain["Payment"] = "Payment";
    Domain["Product"] = "Product";
    Domain["Renewal"] = "Renewal";
    Domain["Store"] = "Store";
    Domain["Subscription"] = "Subscription";
})(Domain = exports.Domain || (exports.Domain = {}));
